import { showSnackbar } from "utils/snack_bar/store/action";
import { executeMutation, executeQuery } from "utils/services/apiServices";
import { CREATE_FAQ, DELETE_FAQ, UPDATE_FAQ } from "../graphql/mutation";
import { actionTypes, FaqInput, FaqProps, FaqUpdateInput } from "./actionType";
import { FETCH_FAQ } from "../graphql/query";

// fetch package
export const fetchFaqRequest = () => ({
  type: actionTypes.FETCH_FAQ_REQUEST,
});

export const fetchFaqSuccess = (payload: FaqProps[]) => ({
  type: actionTypes.FETCH_FAQ_SUCCESS,
  payload,
});

export const fetchFaqFail = (payload: string) => ({
  type: actionTypes.FETCH_FAQ_FAIL,
  payload,
});

export const fetchFaq = () => {
  return async (dispatch: any) => {
    try {
      await dispatch(fetchFaqRequest());
      const response = await executeQuery(FETCH_FAQ);
      const jsonData = response.data?.faqs;
      if (jsonData?.error === null) {
        dispatch(fetchFaqSuccess(jsonData?.data));
      } else {
        dispatch(fetchFaqFail(jsonData?.error));
      }
    } catch (error: any) {
      dispatch(fetchFaqFail("Failed to fetch faq(s)"));
    }
  };
};

//create Faq
export const createFaqSuccess = (payload: FaqProps) => ({
  type: actionTypes.CREATE_FAQ_SUCCESS,
  payload,
});
export const createFaqFail = (payload: string) => ({
  type: actionTypes.CREATE_FAQ_FAIL,
  payload,
});

export const createFaq = (createFaqInput: FaqInput) => {
  return async (dispatch: any) => {
    try {
      const response = await executeMutation(CREATE_FAQ, createFaqInput);
      const jsonData = response.data?.createFAQ;
      if (jsonData?.error === null) {
        dispatch(createFaqSuccess(jsonData?.data));
        dispatch(showSnackbar("Success! Faq created."));
      } else {
        dispatch(createFaqFail(jsonData?.error));
        dispatch(
          showSnackbar(`${jsonData.error ? jsonData.error : "Fail to create."}`)
        );
      }
    } catch (error: any) {
      dispatch(createFaqFail("Something went wrong, Try again later"));
    }
  };
};

//update Faq
export const updateFaqsSuccess = (payload: FaqProps) => ({
  type: actionTypes.UPDATE_FAQ_SUCCESS,
  payload,
});
export const updateFaqsFail = (payload: string) => ({
  type: actionTypes.UPDATE_FAQ_FAIL,
  payload,
});

export const updateFaq = (input: FaqUpdateInput) => {
  return async (dispatch: any) => {
    try {
      const response = await executeMutation(UPDATE_FAQ, input);
      const jsonData = response.data?.updateFAQ;
      if (jsonData?.error === null) {
        dispatch(updateFaqsSuccess(jsonData?.data));
        dispatch(showSnackbar("Success! Faq created."));
      } else {
        dispatch(updateFaqsFail(jsonData?.error));
        dispatch(
          showSnackbar(`${jsonData.error ? jsonData.error : "Fail to update."}`)
        );
      }
    } catch (error: any) {
      dispatch(updateFaqsFail("Something went wrong, Try again later"));
    }
  };
};

//delete Faq
export const deleteFaqsSuccess = (payload: string) => ({
  type: actionTypes.DELETE_FAQ_SUCCESS,
  payload,
});
export const deleteFaqsFail = (payload: string) => ({
  type: actionTypes.DELETE_FAQ_FAIL,
  payload,
});

export const deleteFaq = (id: string) => {
  return async (dispatch: any) => {
    try {
      const input = {
        id: id,
      };
      const response = await executeMutation(DELETE_FAQ, input);
      const jsonData = response.data?.deleteFAQ;
      if (jsonData?.error === null) {
        dispatch(deleteFaqsSuccess(id));
        dispatch(showSnackbar("Success! Faq deleted."));
      } else {
        dispatch(deleteFaqsFail(jsonData?.error));
        dispatch(
          showSnackbar(`${jsonData.error ? jsonData.error : "Fail to delete."}`)
        );
      }
    } catch (error: any) {
      dispatch(deleteFaqsFail("Something went wrong, Try again later"));
    }
  };
};

//RESET
export const ResetFaq = () => ({
  type: actionTypes.RESET_FAQ,
});

export const resetFaq = () => {
  return async (dispatch: any) => {
    dispatch(ResetFaq());
  };
};
